/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Fügen Sie Ihr Fahrzeug für genauere Kostenschätzungen hinzu`
};

const en_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Add your vehicle for more accurate cost estimates`
};

const es_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Añada su vehículo para obtener estimaciones de costos más precisas`
};

const fr_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Ajoutez votre véhicule pour des estimations de coûts plus précises`
};

const it_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi il tuo veicolo per ottenere stime dei costi più precise`
};

const nl_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Voeg uw voertuig toe voor nauwkeurigere kostenramingen`
};

const pt_launchpad__account_modal_add_car = /** @type {(inputs: {}) => string} */ () => {
	return `Adicione o seu veículo para estimativas de custos mais precisas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_add_car(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_add_car", locale)
	if (locale === "de") return de_launchpad__account_modal_add_car(inputs)
	if (locale === "en") return en_launchpad__account_modal_add_car(inputs)
	if (locale === "es") return es_launchpad__account_modal_add_car(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_add_car(inputs)
	if (locale === "it") return it_launchpad__account_modal_add_car(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_add_car(inputs)
	return pt_launchpad__account_modal_add_car(inputs)
};